// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"b7518584","876":"29133416"}[chunkId] + ".chunk.css";
};